import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import { Typography } from "./typography";

const alertVariants = cva("flex items-center gap-2 rounded-[12px] p-4", {
  variants: {
    theme: {
      black: "bg-textSecondary text-white",
      green: "bg-colorGreenLight text-colorGreenDark",
      red: "bg-colorRedLight text-colorRedDark",
      orange: "bg-colorOrangeLight text-colorOrange",
    },
  },
  defaultVariants: {
    theme: "black",
  },
});

export function Alert({
  theme,
  className,
  children,
}: VariantProps<typeof alertVariants> & { children: React.ReactNode; className?: string }) {
  return (
    <Typography size="paragraphXs" color="textPrimary" className={cn(alertVariants({ theme }), className)}>
      <i className="inline-block size-4 i-bp-info flex-shrink-0" />
      <p className={theme == null || theme === "black" ? "" : "text-textPrimary"}>{children}</p>
    </Typography>
  );
}
